export default "__VITE_ASSET__af515152__"